import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const propTypes = {
  links: PropTypes.array.isRequired,
  currentLink: PropTypes.object,
};

const PageBreadcrumbs = ({ links, currentLink }) => {
  return (
    <nav className="PageBreadcrumbs">
      {links.map((link, index) => {
        return (
          <span key={index} className="PageBreadcrumbs-breadcrumb">
            <Link className="link--primary" to={link.href}>
              {link.title}
            </Link>
          </span>
        );
      })}
      {currentLink && (
        <span className="PageBreadcrumbs-breadcrumb PageBreadcrumbs-breadcrumb--current">
          {currentLink.title}
        </span>
      )}
    </nav>
  );
};

PageBreadcrumbs.propTypes = propTypes;
export default PageBreadcrumbs;
